import { newAPI } from '../newAxios';

export const clientReportData = async (payload) => {
    const { clientId, startDate, endDate, reportBy } = payload;
    const res = await newAPI.post(`report/cutomerAccount/${clientId}`, { startDate: startDate, endDate: endDate, ReportBy: reportBy });
    return res.data;
};

export const allClientReportData = async () => {
    const res = await newAPI.get(`report/cutomerAccount`);
    return res.data;
};
